import { createUseBosInfiniteQuery } from '@bos/api';

import { logQueryError } from '../logger/apiErrors/logQueryError';

export const useAppInfiniteQuery = createUseBosInfiniteQuery({
	onLogError: logQueryError,
});
